import { Form } from "../../components/Form";
import { Header } from "../../components/Header";
import { List } from "../../components/List";
import { TotalMoney } from "../../components/TotalMoney";

export const Dashboard = ({
  setIsLogged,
  listTransactions,
  setListTransactions,
  arrFiltered,
  setFilterValue,
}) => {
  return (
    <>
      <Header setIsLogged={setIsLogged} />
      <div className="components-container">
        <div>
          <Form
            listTransactions={listTransactions}
            setListTransactions={setListTransactions}
          />
          <TotalMoney arrFiltered={arrFiltered} />
        </div>
        <List
          listTransactions={listTransactions}
          setListTransactions={setListTransactions}
          arrFiltered={arrFiltered}
          setFilterValue={setFilterValue}
        />
      </div>
    </>
  );
};
